'use-strict';

import React from 'react';
import entities from 'entities';
import ConfigManager from '../../common/configManager/configManager';
import IconFont from '../../components/shared/IconFont';
import TeamLabel from '../../components/shared/TeamLabel';
import PositionMarker from '../../components/shared/PositionMarker';
import LabelLink from '../../components/shared/LabelLink';
import { cleanPlayerName } from '../../utils/cleanString';

const teamsURL = ConfigManager.getFootballTeams('min');
const playersURL = ConfigManager.getFootballPlayers();
const countriesUrl = ConfigManager.getCountriesFlag();
const positionMarker = ConfigManager.getWidgetPositionMarker();
let competitionId;
let gazzanetWidget;

export const imageMap = {
  5861: 1,
  4911: 1,
  1: 1,
  2761: 2,
  1781: 2,
  37: 2,
  33: 2,
  7061: 2,
  7051: 2,
  2: 2,
  14: 3,
  3: 3,
  17: 4,
  6901: 4,
  4821: 4,
  4301: 4,
  24: 4,
  8351: 4,
  8561: 4,
  4: 4,
  7691: 5,
  21: 5,
  8121: 5,
  29: 5,
  36: 5,
  6311: 5,
  5011: 5,
  161: 5,
  4971: 5,
  6881: 5,
  7931: 5,
  3961: 5,
  7121: 5,
  3821: 5,
  7941: 5,
  5: 5,
  4011: 331,
  331: 331,
  4791: 6,
  8551: 6,
  8581: 6,
  6: 6,
  6861: 22,
  39: 22,
  4941: 22,
  104: 22,
  8201: 22,
  4351: 22,
  8211: 22,
  5001: 22,
  7521: 22,
  8191: 22,
  79: 22,
  162: 22,
  4141: 22,
  22: 22,
  7081: 20,
  52: 20,
  53: 20,
  5511: 20,
  2741: 20,
  2911: 20,
  6281: 20,
  2961: 20,
  8171: 20,
  2751: 20,
  8181: 20,
  103: 20,
  8471: 20,
  20: 20,
  101: 19,
  19: 19,
  5641: 501,
  501: 501,
  46: 15,
  15: 15,
  18: 8,
  6481: 8,
  8111: 8,
  28: 8,
  30: 8,
  8: 8,
  8571: 8,
  102: 61,
  61: 61,
  5841: 5841,
  11: 11,
  7: 7,
  5691: 5691,
  8281: 8281,
  9181: 9181,
};

export const teamCLMap = {
  127: 'Inter',
  178: 'Barcellona',
  156: 'Bayern',
  128: 'Juventus',
  43: 'Man. City',
  149: 'PSG',
  14: 'Liverpool',
  8: 'Chelsea',
  1341: 'Zenit',
  186: 'Real Madrid',
  175: 'Atl. Madrid',
  157: 'Borussia',
  459: 'Napoli',
  455: 'Shakhtar',
  6: 'Tottenham',
  215: 'Ajax',
  251: 'Benfica',
  143: 'Lione',
  164: 'Leverkusen',
  857: 'Salisburgo',
  202: 'Olympiacos',
  413: 'Club Brugge',
  191: 'Valencia',
  394: 'Zagabria D.',
  271: 'Mosca',
  414: 'Genk',
  208: 'Galatasaray',
  6339: 'Lipsia',
  273: 'Slavia Praga',
  214: 'Stella Rossa',
  456: 'Atalanta',
  429: 'Lille',
  371: 'Vitória SC',
  5666: 'Wolfsberg',
  67: 'Rangers',
  4169: 'Krasnodar',
  204: 'PSV',
  1963: 'Young Boys',
  198: 'Feyenoord',
  227: 'Ferencváros',
  129: 'Lazio',
  1: 'Man. United',
  5997: 'Olexandria',
  179: 'Siviglia',
  383: 'Trabzonspor',
  255: 'Sporting CP',
  194: 'Dinamo Kiev',
  280: 'LASK',
  61: 'Celtic',
  313: 'AZ Alkmaar',
  3751: 'Astana',
  172: 'Wolfsburg',
  3107: 'FK Qarabag',
  201: 'Porto',
  177: 'Espanyol',
  678: 'Gent',
  2628: 'CFR Cluj',
  150: 'Rennes',
  152: 'St. Étienne',
  993: 'Malmo',
  373: 'Std Liegi',
  121: 'Roma',
  6128: 'Ludogorets',
  481: 'Basilea',
  2161: 'Dudelange',
  683: 'Borussia',
  378: 'Besiktas',
  2133: 'Istanbul',
  935: 'Lugano',
  159: 'Francoforte',
  197: 'Rosenborg',
  479: 'APOEL',
  39: 'Wolverhampton',
  3: 'Arsenal',
  569: 'Copenaghen',
  1450: 'Getafe',
  211: 'S. Bratislava',
  216: 'P. Belgrado',
  372: 'Braga',
  1340: 'CSKA Mosca',
  367: 'R. Ceca',
  537: 'Bosnia-Erz.',
  504: 'N. Macedonia',
  117: 'Irl. del Nord',
  3907: 'FC Progrès',
  916: 'TNS',
  1490: 'Shamrock',
  3758: 'FC Kaisar',
  2830: 'Buducnost',
  12975: 'Ararat A.',
  8858: 'Lincoln',
  1788: 'Lok. Plovdiv',
  474: 'Olimpija',
  2856: 'Zrinjski',
  2768: 'Connah\'s Q.',
  1406: 'Djurgårdens',
  4089: 'Sfintul G.',
  3012: 'H. Beer Sheva',
  1016: 'Lok Tbilisi',
  1003: 'Apollon',
  13197: 'FC Kolos',
  2842: 'Borac BL',
  4950: 'Hartberg',
  2959: 'Dunajská S.',
  265: 'Steaua Buc.',
  2046: 'Honvéd',
  2107: 'R. Ceca U21',
};


const reusableCols = {
  title: {
    colName: 'title',
    // eslint-disable-next-line
    label: function (colName) {
      const titleLabels = {
        'Round of 32': 'Sedicesimi di finale',
        'Round of 16': 'Ottavi di finale',
        'Quarter-Finals': 'Quarti di finale',
        'Semi-Finals': 'Semifinali',
        Round: 'GIORNATA 1',
        'Play-Offs': 'GIORNATA 2',
        '3rd and 4th Place': 'Finale per il 3° posto',
        Final: 'Finale',
        A: 'GRUPPO A',
        B: 'GRUPPO B',
        C: 'GRUPPO C',
        D: 'GRUPPO D',
        E: 'GRUPPO E',
        F: 'GRUPPO F',
        G: 'GRUPPO G',
        H: 'GRUPPO H',
        I: 'GRUPPO I',
        J: 'GRUPPO J',
        K: 'GRUPPO K',
        L: 'GRUPPO L',
      };
      return titleLabels[colName];
    },
    width: 22,
    position: 'absolute',
    left: '1.2%',
    top: '2px',
    caps: 'uppercase',
    alignment: 'flex-start',
    sortingValue(teamName) {
      return teamName;
    },
    rowLabel(colName) {
      return this[colName];
    },
    notNormalize: true,
    order: 0,
    hideTooltip: true,
  },
};

const tableConfigurationSet = {
  competitionTeams: {
    title: {
      colName: 'title',
      // eslint-disable-next-line
      label: function () {
        return 'Squadra';
      },
      width: 34,
      position: 'absolute',
      left: '30px',
      alignment: 'flex-start',
      sortingValue(teamName) {
        return teamName;
      },
      rowLabel(colName) {
        return this[colName];
      },
      notNormalize: true,
      order: 0,
      hideTooltip: true,
    },
    teamName: {
      colName: 'teamName',
      label(colName) {
        return this[colName];
      },
      width: 28,
      alignment: 'flex-start',
      sortingValue(teamName) {
        return teamName;
      },
      rowLabel(colName) {
        //return this[colName];
        return (
          <LabelLink
            label={this[colName]}
            path={ConfigManager.prettyTeamUrl(1, competitionId, process.env.REACT_APP_SITE, this[colName])}
            hideArrow
          />
        );
      },
      order: 0,
      hideTooltip: true,
    },
    teamId: {
      colName: 'teamId',
      label(colName) {
        return this[colName];
      },
      width: 13,
      sortingValue(teamName) {
        return teamName;
      },
      rowLabel() {
        return (
          <TeamLabel
            image={`${teamsURL}${this.teamId}.png`}
          />
        );
      },
      order: 0,
      notNormalize: true,
      hideTooltip: true,
    },
    form: {
      colName: 'form',
      label(colName) {
        return this[colName];
      },
      width: 18,
      sortingValue(form) {
        return (form.match(/W/g) || []).length;
      },
      rowLabel(colName) {
        const formLabel = {
          W: {
            label: 'V',
            color: 'green',
          },
          L: {
            label: 'P',
            color: 'whiteRed',
          },
          D: {
            label: 'N',
            color: 'lighterGray',
          },
        };
        let form = this[colName];
        if (form.length > 5) {
          form = form.slice(-5);
        }
        return (
          form && form.reverse().map((res, index) => (
            <LabelLink
              color={formLabel[res.label].color}
              label={formLabel[res.label].label}
              isForm
              key={index}
              weight="bold"
              path={`#${res.match.homeTeam.teamName}-${res.match.awayTeam.teamName}`}
              hideArrow
              isTitleNarrowMedium
            />
          ))
        );
      },
      order: 0,
      hideTooltip: true,
    },
    startingPosition: {
      colName: 'startingPosition',
      label(colName) {
        return this[colName];
      },
      width: 5,
      sortingValue(teamName) {
        return teamName;
      },
      rowLabel() {
        if ((this.position - this.startingPosition) < 0) {
          return (
            <IconFont
              className="icon-matchcenter-up-triangle"
              color="green"
              font={12}
            />
          );
        } else if ((this.position - this.startingPosition) > 0) {
          return (
            <IconFont
              className="icon-matchcenter-up-triangle"
              color="red"
              font={12}
              rotate={90}
            />
          );
        }
        return (
          <IconFont
            className="icon-matchcenter-equal"
            font={12}
          />
        );
      },
      order: 0,
      hideTooltip: true,
    },
    joinCols: {
      colName: 'leftCol:rightCol',
      width: 10,
      label(colName) {
        const colsName = colName.split(':');
        return `${this[colsName[0]]}:${this[colsName[1]]}`;
      },
      rowLabel(colName) {
        const colsName = colName.split(':');
        return `${this[colsName[0]]}:${this[colsName[1]]}`;
      },
      sortingValue(value) {
        return value;
      },
      order: 0,
      hideTooltip: true,
    },
    points: {
      colName: 'points',
      width: 5,
      weight: 'bold',
      size: 1,
      label(colName) {
        return this[colName];
      },
      rowLabel(colName) {
        return this[colName];
      },
      sortingValue(value) {
        return value;
      },
      order: 0,
      hideTooltip: true,
    },
    position: {
      colName: 'position',
      width: 5,
      label() {
        return (
          <PositionMarker
            bgColor="none"
            color="black"
          />
        );
      },
      rowLabel(colName) {
        const { qualification } = this;
        return (
          qualification && qualification.qualify ?
            <PositionMarker
              bgColor={positionMarker && positionMarker[qualification.qualify] && positionMarker[qualification.qualify][qualification.method] ? positionMarker[qualification.qualify][qualification.method] : ''}
              label={this[colName]}
              color="black"
            /> :
            <PositionMarker
              bgColor="none"
              label={this[colName]}
              color="black"
            />
        );
      },
      sortingValue(value) {
        return value;
      },
      order: 0,
      notNormalize: true,
      hideTooltip: true,
    },
    defaultCols: {
      colName: 'default',
      width: 5,
      label(colName) {
        return this[colName];
      },
      rowLabel(colName) {
        return this[colName];
      },
      sortingValue(value) {
        return value;
      },
      order: 0,
      joinDirection: '',
      hideTooltip: true,
    },
  },
  competitionMarkers: {
    title: {
      colName: 'title',
      // eslint-disable-next-line
      label: function () {
        return 'Giocatore';
      },
      width: 34,
      position: 'absolute',
      left: '3%',
      alignment: 'flex-start',
      sortingValue(teamName) {
        return teamName;
      },
      rowLabel(colName) {
        return this[colName];
      },
      notNormalize: true,
      order: 0,
      hideTooltip: true,
    },
    position: {
      colName: 'position',
      width: 1,
      label(colName) {
        return this[colName];
      },
      rowLabel(colName) {
        return this[colName];
      },
      sortingValue(value) {
        return value;
      },
      order: 0,
      joinDirection: '',
      hideTooltip: true,
    },
    teamName: {
      colName: 'teamName',
      label(colName) {
        return this[colName];
      },
      width: 25,
      alignment: 'flex-start',
      overrideMargin: '0',
      sortingValue(teamName) {
        return teamName;
      },
      rowLabel(colName) {
        //return this[colName];
        if (competitionId === 21) {
          return (
            <LabelLink
              label={this[colName]}
              path={ConfigManager.prettyTeamUrl(1, competitionId, process.env.REACT_APP_SITE, this[colName])}
              hideArrow
            />
          );
        } else {
          return this[colName];
        }
      },
      order: 0,
      hideTooltip: true,
    },
    teamId: {
      colName: 'teamId',
      label(colName) {
        return this[colName];
      },
      width: 5,
      sortingValue(teamName) {
        return teamName;
      },
      rowLabel() {
        return (
          <TeamLabel
            image={`${teamsURL}${this.teamId}.png`}
          />
        );
      },
      order: 0,
      hideTooltip: true,
    },
    playerId: {
      colName: 'playerId',
      label(colName) {
        return this[colName];
      },
      width: 7,
      sortingValue(teamName) {
        return teamName;
      },
      rowLabel() {
        const formattedDate = this.playerBirthDate ? this.playerBirthDate.split('-').reverse().join('') : '';
        const firstName = this.playerFirstName ? this.playerFirstName.toLowerCase() : '';
        const lastName = this.playerSecondName ? this.playerSecondName.toLowerCase() : '';
        const formattedPlayer = (firstName && lastName) ? `${firstName}_${lastName}` : '';
        return (
          <TeamLabel
            isPlayer
            image={`${playersURL}${cleanPlayerName(formattedPlayer, '_')}_${formattedDate}.png`}
          />
        );
      },
      order: 0,
      hideTooltip: true,
    },
    playerName: {
      colName: 'playerName',
      label(colName) {
        return this[colName];
      },
      width: 25,
      alignment: 'flex-start',
      sortingValue(teamName) {
        return teamName;
      },
      rowLabel(colName) {
        const gazzanetName = this.playerName;
        const [name, surname] = gazzanetName.split(' ');
        let returnedName = surname;
        if (!surname) {
          returnedName = name;
        }
        return (<LabelLink
          label={gazzanetWidget ? entities.decodeHTML(returnedName) : entities.decodeHTML(this[colName])}
          path={ConfigManager.getPlayerUrl(entities.decodeHTML(this[colName]), this.playerId, 1, process.env.REACT_APP_SITE)}
          hideArrow
          margin={gazzanetWidget ? '0 5px' : '0px'}
        />);
      },
      order: 0,
      hideTooltip: true,
    },
    playerCountry: {
      colName: 'playerCountry',
      label(colName) {
        return this[colName];
      },
      width: 5,
      sortingValue(teamName) {
        return teamName;
      },
      rowLabel() {
        return (
          <TeamLabel
            image={`${countriesUrl}${this.playerCountry}.jpg`}
            isFlag
          />
        );
      },
      order: 0,
      hideTooltip: true,
    },
    playerRole: {
      colName: 'playerRole',
      width: 15,
      alignment: 'left',
      overridePadding: '0px 0px 0px 15px',
      size: 0.85,
      label(colName) {
        return this[colName];
      },
      rowLabel(colName) {
        return this[colName];
      },
      sortingValue(value) {
        return value;
      },
      order: 0,
      hideTooltip: true,
    },
    goals: {
      colName: 'goals',
      width: 6,
      weight: 'bold',
      size: 0.85,
      label(colName) {
        return this[colName];
      },
      rowLabel(colName) {
        return this[colName];
      },
      sortingValue(value) {
        return value;
      },
      order: 0,
      hideTooltip: true,
    },
    defaultCols: {
      colName: 'default',
      width: 6,
      label(colName) {
        return this[colName];
      },
      rowLabel(colName) {
        return this[colName];
      },
      sortingValue(value) {
        return value;
      },
      order: 0,
      joinDirection: '',
      hideTooltip: true,
    },
  },
  rugbyStandings: {
    title: {
      colName: 'title',
      // eslint-disable-next-line
      label: function () {
        return 'Squadra';
      },
      width: 34,
      position: 'absolute',
      left: '30px',
      alignment: 'flex-start',
      sortingValue(teamName) {
        return teamName;
      },
      rowLabel(colName) {
        return this[colName];
      },
      notNormalize: true,
      order: 0,
      hideTooltip: true,
    },
    teamName: {
      colName: 'teamName',
      label(colName) {
        return this[colName];
      },
      width: 28,
      alignment: 'flex-start',
      sortingValue(teamName) {
        return teamName;
      },
      rowLabel(colName) {
        //return this[colName];
        return (
          <LabelLink
            label={this[colName]}
            path={ConfigManager.prettyTeamUrl(1, competitionId, process.env.REACT_APP_SITE, this[colName])}
            hideArrow
          />
        );
      },
      order: 0,
      hideTooltip: true,
    },
    teamId: {
      colName: 'teamId',
      label(colName) {
        return this[colName];
      },
      width: 13,
      sortingValue(teamName) {
        return teamName;
      },
      rowLabel() {
        return (
          <TeamLabel
            image={`${ConfigManager.getRugbyTeams('min')}${this.teamId}.png`}
          />
        );
      },
      order: 0,
      notNormalize: true,
      hideTooltip: true,
    },
    joinCols: {
      colName: 'leftCol:rightCol',
      width: 10,
      label(colName) {
        const colsName = colName.split(':');
        return `${this[colsName[0]]}:${this[colsName[1]]}`;
      },
      rowLabel(colName) {
        const colsName = colName.split(':');
        return `${this[colsName[0]]}:${this[colsName[1]]}`;
      },
      sortingValue(value) {
        return value;
      },
      order: 0,
      hideTooltip: true,
    },
    points: {
      colName: 'points',
      width: 5,
      weight: 'bold',
      size: 1,
      label(colName) {
        return this[colName];
      },
      rowLabel(colName) {
        return this[colName];
      },
      sortingValue(value) {
        return value;
      },
      order: 0,
      hideTooltip: true,
    },
    position: {
      colName: 'position',
      width: 5,
      label() {
        return (
          <PositionMarker
            bgColor="none"
            color="black"
          />
        );
      },
      rowLabel(colName) {
        const { qualification } = this;
        return (
          qualification && qualification.qualify ?
            <PositionMarker
              bgColor={positionMarker[qualification.qualify][qualification.method]}
              label={this[colName]}
              color="black"
            /> :
            <PositionMarker
              bgColor="none"
              label={this[colName]}
              color="black"
            />
        );
      },
      sortingValue(value) {
        return value;
      },
      order: 0,
      notNormalize: true,
      hideTooltip: true,
    },
    defaultCols: {
      colName: 'default',
      width: 5,
      label(colName) {
        return this[colName];
      },
      rowLabel(colName) {
        return this[colName];
      },
      sortingValue(value) {
        return value;
      },
      order: 0,
      joinDirection: '',
      hideTooltip: true,
    },
  },
};

const tableConfigurationSetMobile = {
  competitionTeams: {
    title: {
      colName: 'title',
      // eslint-disable-next-line
      label: function () {
        return 'Squadra';
      },
      width: 34,
      position: 'absolute',
      left: '1.2%',
      alignment: 'flex-start',
      sortingValue(teamName) {
        return teamName;
      },
      rowLabel(colName) {
        return this[colName];
      },
      notNormalize: true,
      order: 0,
      hideTooltip: true,
    },
    teamName: {
      colName: 'teamName',
      label(colName) {
        return this[colName];
      },
      width: 28,
      alignment: 'flex-start',
      sortingValue(teamName) {
        return teamName;
      },
      rowLabel(colName) {
        //return this[colName];
        return (
          <LabelLink
            label={this[colName]}
            path={ConfigManager.prettyTeamUrl(1, competitionId, process.env.REACT_APP_SITE, this[colName])}
            hideArrow
          />
        );
      },
      order: 0,
      hideTooltip: true,
    },
    teamId: {
      colName: 'teamId',
      label(colName) {
        return this[colName];
      },
      width: 13,
      sortingValue(teamName) {
        return teamName;
      },
      rowLabel() {
        return (
          <TeamLabel
            image={`${teamsURL}${this.teamId}.png`}
          />
        );
      },
      order: 0,
      notNormalize: true,
      hideTooltip: true,
    },
    form: {
      colName: 'form',
      label(colName) {
        return this[colName];
      },
      width: 18,
      sortingValue(form) {
        return (form.match(/W/g) || []).length;
      },
      rowLabel(colName) {
        const formLabel = {
          W: {
            label: 'V',
            color: 'green',
          },
          L: {
            label: 'P',
            color: 'whiteRed',
          },
          D: {
            label: 'N',
            color: 'lighterGray',
          },
        };
        let form = this[colName];
        if (form.length > 5) {
          form = form.slice(-5);
        }
        return (
          form && form.reverse().map((res, index) =>
            (<LabelLink
              color={formLabel[res.label].color}
              label={formLabel[res.label].label}
              isForm
              key={index}
              weight="bold"
              path={`#${res.match.homeTeam.teamName}-${res.match.awayTeam.teamName}`}
              hideArrow
              isTitleNarrowMedium
            />))
        );
      },
      order: 0,
      hideTooltip: true,
    },
    startingPosition: {
      colName: 'startingPosition',
      label(colName) {
        return this[colName];
      },
      width: 5,
      sortingValue(teamName) {
        return teamName;
      },
      rowLabel() {
        if ((this.position - this.startingPosition) < 0) {
          return (
            <IconFont
              className="icon-matchcenter-up-triangle"
              color="green"
              font={12}
            />
          );
        } else if ((this.position - this.startingPosition) > 0) {
          return (
            <IconFont
              className="icon-matchcenter-up-triangle"
              color="red"
              font={12}
              rotate={90}
            />
          );
        }
        return (
          <IconFont
            className="icon-matchcenter-equal"
            font={12}
          />
        );
      },
      order: 0,
      hideTooltip: true,
    },
    joinCols: {
      colName: 'leftCol:rightCol',
      width: 10,
      label(colName) {
        const colsName = colName.split(':');
        return `${this[colsName[0]]}:${this[colsName[1]]}`;
      },
      rowLabel(colName) {
        const colsName = colName.split(':');
        return `${this[colsName[0]]}:${this[colsName[1]]}`;
      },
      sortingValue(value) {
        return value;
      },
      order: 0,
      hideTooltip: true,
    },
    points: {
      colName: 'points',
      width: 5,
      weight: 'bold',
      size: 1,
      label(colName) {
        return this[colName];
      },
      rowLabel(colName) {
        return this[colName];
      },
      sortingValue(value) {
        return value;
      },
      order: 0,
      hideTooltip: true,
    },
    position: {
      colName: 'position',
      width: 5,
      label() {
        return (
          <PositionMarker
            bgColor="none"
            color="black"
          />
        );
      },
      rowLabel(colName) {
        const { qualification } = this;
        return (
          qualification && qualification.qualify ?
            <PositionMarker
              bgColor={positionMarker && positionMarker[qualification.qualify] && positionMarker[qualification.qualify][qualification.method] ? positionMarker[qualification.qualify][qualification.method] : ''}
              label={this[colName]}
              color="black"
            /> :
            <PositionMarker
              bgColor="none"
              label={this[colName]}
              color="black"
            />
        );
      },
      sortingValue(value) {
        return value;
      },
      order: 0,
      notNormalize: true,
      hideTooltip: true,
    },
    defaultCols: {
      colName: 'default',
      width: 5,
      label(colName) {
        return this[colName];
      },
      rowLabel(colName) {
        return this[colName];
      },
      sortingValue(value) {
        return value;
      },
      order: 0,
      joinDirection: '',
      hideTooltip: true,
    },
  },
  competitionMarkers: {
    title: {
      colName: 'title',
      // eslint-disable-next-line
      label: function () {
        return 'Giocatore';
      },
      width: 34,
      position: 'absolute',
      left: '1.2%',
      alignment: 'flex-start',
      sortingValue(teamName) {
        return teamName;
      },
      rowLabel(colName) {
        return this[colName];
      },
      notNormalize: true,
      order: 0,
      hideTooltip: true,
    },
    position: {
      colName: 'position',
      width: 2,
      label(colName) {
        return this[colName];
      },
      rowLabel(colName) {
        return this[colName];
      },
      sortingValue(value) {
        return value;
      },
      order: 0,
      joinDirection: '',
      hideTooltip: true,
    },
    teamName: {
      colName: 'teamName',
      label(colName) {
        return this[colName];
      },
      width: 24,
      alignment: 'flex-start',
      overrideMargin: '0',
      sortingValue(teamName) {
        return teamName;
      },
      rowLabel(colName) {
        //return this[colName];
        return (
          <LabelLink
            label={this[colName]}
            path={ConfigManager.prettyTeamUrl(1, competitionId, process.env.REACT_APP_SITE, this[colName])}
            hideArrow
          />
        );
      },
      order: 0,
      hideTooltip: true,
    },
    teamId: {
      colName: 'teamId',
      label(colName) {
        return this[colName];
      },
      width: 5,
      sortingValue(teamName) {
        return teamName;
      },
      rowLabel() {
        return (
          <TeamLabel
            image={`${teamsURL}${this.teamId}.png`}
          />
        );
      },
      order: 0,
      hideTooltip: true,
    },
    playerId: {
      colName: 'playerId',
      label(colName) {
        return this[colName];
      },
      width: 7,
      sortingValue(teamName) {
        return teamName;
      },
      rowLabel() {
        const formattedDate = this.playerBirthDate ? this.playerBirthDate.split('-').reverse().join('') : '';
        const firstName = this.playerFirstName ? entities.decodeHTML(this.playerFirstName.toLowerCase()) : '';
        const lastName = this.playerSecondName ? entities.decodeHTML(this.playerSecondName.toLowerCase()) : '';
        const formattedPlayer = (firstName && lastName) ? `${firstName}_${lastName}` : '';
        return (
          <TeamLabel
            isPlayer
            image={`${playersURL}${cleanPlayerName(formattedPlayer, '_')}_${formattedDate}.png`}
          />
        );
      },
      order: 0,
      hideTooltip: true,
    },
    playerName: {
      colName: 'playerName',
      label(colName) {
        return this[colName];
      },
      width: 24,
      alignment: 'flex-start',
      sortingValue(teamName) {
        return teamName;
      },
      rowLabel(colName) {
        const gazzanetName = this.playerName;
        const [name, surname] = gazzanetName.split(' ');
        let returnedName = surname;
        if (!surname) {
          returnedName = name;
        }
        return (<LabelLink
          label={gazzanetWidget ? entities.decodeHTML(returnedName) : entities.decodeHTML(this[colName])}
          path={ConfigManager.getPlayerUrl(entities.decodeHTML(this[colName]), this.playerId, 1, process.env.REACT_APP_SITE)}
          hideArrow
          margin={gazzanetWidget ? '0 5px' : '0px'}
        />);
      },
      order: 0,
      hideTooltip: true,
    },
    playerCountry: {
      colName: 'playerCountry',
      label(colName) {
        return this[colName];
      },
      width: 5,
      sortingValue(teamName) {
        return teamName;
      },
      rowLabel() {
        return (
          <TeamLabel
            image={`${countriesUrl}${this.playerCountry}.jpg`}
            isFlag
          />
        );
      },
      order: 0,
      hideTooltip: true,
    },
    playerRole: {
      colName: 'playerRole',
      width: 15,
      alignment: 'left',
      overridePadding: '0px 0px 0px 15px',
      size: 0.85,
      label(colName) {
        return this[colName];
      },
      rowLabel(colName) {
        return this[colName];
      },
      sortingValue(value) {
        return value;
      },
      order: 0,
      hideTooltip: true,
    },
    goals: {
      colName: 'goals',
      width: 6,
      weight: 'bold',
      size: 0.85,
      label(colName) {
        return this[colName];
      },
      rowLabel(colName) {
        return this[colName];
      },
      sortingValue(value) {
        return value;
      },
      order: 0,
      hideTooltip: true,
    },
    defaultCols: {
      colName: 'default',
      width: 6,
      label(colName) {
        return this[colName];
      },
      rowLabel(colName) {
        return this[colName];
      },
      sortingValue(value) {
        return value;
      },
      order: 0,
      joinDirection: '',
      hideTooltip: true,
    },
  },
};

export default class TableConfiguration {
  constructor(tableName, isMobile, competitionIdPass, isGazzanet) {
    this.currentTable = tableName;
    this.colsArray = tableConfigurationSet[tableName];
    this.orderCols = ConfigManager.getWidgetColsOrder(tableName);
    let joinedCols = ConfigManager.getWidgetJoinedCols(tableName);
    if (!Array.isArray(joinedCols)) {
      joinedCols = [joinedCols];
    }
    this.joinedCols = joinedCols;
    this.isMobile = isMobile;
    competitionId = Number(competitionIdPass);
    gazzanetWidget = isGazzanet;
    this.colsArray = !this.isMobile ? tableConfigurationSet[tableName] : tableConfigurationSetMobile[tableName];
    this.skipCols = !isMobile ? ConfigManager.getWidgetSkipCols(tableName).colName : ConfigManager.getWidgetSkipCols(tableName).isMobile;
    this.hasJoin = false;
  }

  isJoinedLeftCols(colName) {
    if (this.joinedCols) {
      for (const col of this.joinedCols) {
        if (col.leftCol === colName) {
          return true;
        }
      }
    }
    return false;
  }

  isJoinedRightCols(colName) {
    if (this.joinedCols) {
      for (const col of this.joinedCols) {
        if (col.rightCol === colName) {
          return true;
        }
      }
    }
    return false;
  }

  isInSkipCols(value) {
    return this.skipCols.indexOf(value);
  }

  substituteJoinedCols = (colsConfiguration) => {
    for (const joinedCol of this.joinedCols) {
      const onlyJoinCols = colsConfiguration.filter(col => (((col.joinDirection === 'left' && col.colName === joinedCol.leftCol) || (col.joinDirection === 'right' && col.colName === joinedCol.rightCol))));
      const colJoin = Object.assign({}, this.colsArray.joinCols);
      const leftCol = onlyJoinCols.filter(col => (col.joinDirection === 'left'))[0];
      const rightCol = onlyJoinCols.filter(col => (col.joinDirection === 'right'))[0];
      colJoin.colName = `${leftCol.colName}:${rightCol.colName}`;
      colJoin.order = Math.min(leftCol.order, rightCol.order);
      colsConfiguration.push(colJoin);
    }
    return colsConfiguration.filter(col => ((col.joinDirection !== 'left' && col.joinDirection !== 'right')));
  };

  normalizeColsWidth = (colsConfiguration) => {
    const sum = colsConfiguration.reduce((counter, a) => {
      if (!a.notNormalize) {
        counter += a.width;
      }
      return counter;
    }, 0);
    if (sum < 100) {
      const increaseValue = Math.ceil((100 - sum) / colsConfiguration.length);
      for (const col of colsConfiguration) {
        if (!col.notNormalize) {
          col.width += increaseValue;
        }
      }
    }
    return colsConfiguration;
  };

  normalizeColsWidthWithTitle = (colsConfiguration) => {
    const sum = colsConfiguration.reduce((counter, a) => {
      if (!a.notNormalize) {
        counter += a.width;
      }
      return counter;
    }, 0);
    if (sum < 100) {
      const increaseValue = Math.ceil((100 - sum) / (colsConfiguration.length - 1));
      for (const col of colsConfiguration) {
        if (!col.notNormalize) {
          col.width += increaseValue;
        }
      }
    }
    return colsConfiguration;
  };

  createDefaultCol = (colName) => {
    const colDef = Object.assign({}, this.colsArray.defaultCols);
    colDef.colName = colName;
    colDef.order = this.orderCols[colName];
    if (this.isJoinedLeftCols(colName)) {
      colDef.joinDirection = 'left';
      this.hasJoin = true;
    } else if (this.isJoinedRightCols(colName)) {
      colDef.joinDirection = 'right';
      this.hasJoin = true;
    }
    return colDef;
  };

  createCustomCol = (colName, isHeader = false) => {
    const col = Object.assign({}, this.colsArray[colName]);
    col.order = this.orderCols[colName];
    if (isHeader && col.hasOwnProperty('alignmentHeader')) {
      col.alignment = col.alignmentHeader;
    }
    return col;
  };

  createColumnsConfiguration(colsArray) {
    switch (this.currentTable) {
      case 'competitionRoundMatches':
        return this.normalizeColsWidth(this.colsArray);
      default:
        return this.addOthersCols(colsArray);
    }
  }

  createColumnsConfigurationWithTitle(colsArray, title) {
    switch (this.currentTable) {
      case 'competitionRoundMatches':
        return this.addTitle(!this.isMobile ? tableConfigurationSet.competitionRoundMatchesHeader : tableConfigurationSetMobile.competitionRoundMatchesHeader, title);
      default:
        return this.addOthersColsWithTitle(colsArray, title);
    }
  }

  addOthersCols(colsArray) {
    let colsConfiguration = [];
    for (const colName of colsArray) {
      if (this.isInSkipCols(colName) >= 0) {
        //eslint-disable-next-line
        continue;
      }
      if (this.colsArray.hasOwnProperty(colName)) {
        colsConfiguration.push(this.createCustomCol(colName));
      } else {
        colsConfiguration.push(this.createDefaultCol(colName));
      }
    }
    if (this.hasJoin) {
      colsConfiguration = this.substituteJoinedCols(colsConfiguration);
      this.hasJoin = false;
    }
    colsConfiguration = this.normalizeColsWidth(colsConfiguration);
    return colsConfiguration.sort((colA, colB) => (colA.order - colB.order));
  }

  // Only for table header
  addOthersColsWithTitle(colsArray, title) {
    let colsConfiguration = [];
    //let hasJoin = false;
    const colTitle = Object.assign({}, this.colsArray.title);
    colTitle.colName = title;
    colTitle.order = this.orderCols.title;
    colsConfiguration.push(colTitle);
    for (const colName of colsArray) {
      if (this.isInSkipCols(colName) >= 0) {
        //eslint-disable-next-line
        continue;
      }
      if (this.colsArray.hasOwnProperty(colName)) {
        colsConfiguration.push(this.createCustomCol(colName, true));
      } else {
        colsConfiguration.push(this.createDefaultCol(colName));
      }
    }
    if (this.hasJoin) {
      colsConfiguration = this.substituteJoinedCols(colsConfiguration);
      this.hasJoin = false;
    }
    colsConfiguration = this.normalizeColsWidthWithTitle(colsConfiguration);
    return colsConfiguration.sort((colA, colB) => (colA.order - colB.order));
  }

  addTitle(colsArray, title) {
    const colsConfiguration = [];
    const colTitle = Object.assign({}, reusableCols.title);
    colTitle.colName = title;
    colTitle.order = this.orderCols.title;
    colsConfiguration.push(colTitle);
    return colsConfiguration.concat(colsArray);
  }
}



// WEBPACK FOOTER //
// ./src/utils/tableConfiguration/tableConfiguration.js